module.exports = __webpack_public_path__ + "static/media/material-arrow-upward.3abb1cbf.svg";